"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SupportTicketService = /** @class */ (function () {
    function SupportTicketService($resource) {
        this.$resource = $resource;
        this.repository = $resource('/Partner/api/v2/SupportTicketApi/Post');
    }
    SupportTicketService.prototype.createTicket = function (model) {
        return this.repository.save(model).$promise;
    };
    return SupportTicketService;
}());
exports.SupportTicketService = SupportTicketService;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3VwcG9ydFRpY2tldC5zZXJ2aWNlLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsic3VwcG9ydFRpY2tldC5zZXJ2aWNlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7O0FBR0E7SUFHSSw4QkFBb0IsU0FBNEM7UUFBNUMsY0FBUyxHQUFULFNBQVMsQ0FBbUM7UUFDNUQsSUFBSSxDQUFDLFVBQVUsR0FBRyxTQUFTLENBQUMsdUNBQXVDLENBQUMsQ0FBQztJQUN6RSxDQUFDO0lBRU0sMkNBQVksR0FBbkIsVUFBb0IsS0FBcUI7UUFDckMsT0FBTyxJQUFJLENBQUMsVUFBVSxDQUFDLElBQUksQ0FBQyxLQUFLLENBQUMsQ0FBQyxRQUFRLENBQUM7SUFDaEQsQ0FBQztJQUNMLDJCQUFDO0FBQUQsQ0FBQyxBQVZELElBVUM7QUFWWSxvREFBb0IifQ==